export const emailNotificationsTypes = {
  AVAILABLE_ANNOUNCEMENT_FROM_FOLLOWED_ANALYST: 'AVAILABLE_ANNOUNCEMENT_FROM_FOLLOWED_ANALYST',
  WATCHLIST_UPDATE: 'WATCHLIST_UPDATE',
  COMPLETED_ISIN_UPLOAD: 'COMPLETED_ISIN_UPLOAD',
  AVAILABLE_RATING: 'AVAILABLE_RATING',
};